'use strict';

const Mn = require('backbone.marionette');
const Template = require('framework/ui/template/readmore.hbs');

module.exports = Mn.View.extend({
    template: Template,
    events: {
        'click': 'more'
    },

    more: function() {
        this.model.more(10);
    }
});



// WEBPACK FOOTER //
// ./framework/ui/view/readmore.js